module.exports = __webpack_public_path__ + "media/images/img_horizontal_arrow_white-9badd2bf.png";